<template>
  <el-row :gutter="20">
    <el-col :span="10">
      <w-agent-manager-table ref="agentManagerTable" @get-agent-manager-id="getAgentManagerId"></w-agent-manager-table>
    </el-col>
    <el-col :span="8">
      <w-agent-physical-obj-table :checked-obj-list="checkedObjList" ref="agentPhysicalObjTable"></w-agent-physical-obj-table>
    </el-col>
    <el-col :span="6">
      <w-agent-selected-obj-table type="agentManager" :checked-obj-list="checkedObjList" :origin-checked-obj-ids="originCheckedObjIds"
      :selected-agent-manager-group-id="selectedAgentManagerGroupId" :selected-agent-manager-id="selectedAgentManagerId" @load-data="loadData"
      @reload-obj-list="reloadObjList" :total="agentSelectedObjTableTotal" ref="agentSelectedObjTable" :activeTab="activeTab" />
    </el-col>
  </el-row>
</template>

<script>
import { isEqual, isNil, cloneDeep } from 'lodash';
import AgentSettingsAPI from '@/api/settings/common/agent-settings';
import WAgentManagerTable from './components/AgentManagerTable';
import WAgentPhysicalObjTable from './components/AgentPhysicalObjTable';
import WAgentSelectedObjTable from './components/AgentSelectedObjTable';

export default {
  name: 'WAgentManager',
  components: {
    WAgentManagerTable,
    WAgentPhysicalObjTable,
    WAgentSelectedObjTable,
  },
  props: {
    activeTab: String,
  },
  watch: {
    selectedAgentManagerId() {
      this.loadData();
    },
    originCheckedObjList() {
      const originCheckedObjIds = [];
      this.checkedObjList.forEach((obj) => {
        if (!originCheckedObjIds.includes(obj.objId)) {
          originCheckedObjIds.push(obj.objId);
        }
      });
      this.originCheckedObjIds = originCheckedObjIds;
    },
  },
  data() {
    return {
      selectedAgentManagerGroupId: 0,
      selectedAgentManagerId: 0,
      checkedObjList: [],
      originCheckedObjList: [],
      originCheckedObjIds: [],
      agentSelectedObjTableTotal: 0,
    };
  },
  mounted() {
    this.$refs.agentManagerTable.loadData();
    this.$refs.agentPhysicalObjTable.initData();
  },
  methods: {
    loadData(flag) {
      if (!flag) {
        this.$refs.agentSelectedObjTable.onAgentTableClearFilter();
      }
      this.$refs.agentManagerTable.loadData();
      if (isNil(this.selectedAgentManagerId)) {
        this.checkedObjList = [];
        this.originCheckedObjList = [];
        this.$nextTick(() => {
          this.$refs.agentPhysicalObjTable.setCheckObjTable();
        });
        return;
      }

      const params = {
        agentManagerId: this.selectedAgentManagerId,
        ...this.$refs.agentSelectedObjTable.getPagingParams,
      };

      AgentSettingsAPI.getObjectOfAgentManager(params).then((response) => {
        this.checkedObjList = cloneDeep(response.data.data);
        this.originCheckedObjList = cloneDeep(response.data.data);
        this.$nextTick(() => {
          const curManagetypeId = this.$refs.agentPhysicalObjTable.managetypeId;
          if (!isNil(curManagetypeId)) {
            const firstManagetypeId = this.$refs.agentPhysicalObjTable.managetypeList[0].managetypeId;
            if (isEqual(firstManagetypeId, curManagetypeId)) {
              this.$refs.agentPhysicalObjTable.setCheckObjTable();
            } else {
              this.$refs.agentPhysicalObjTable.managetypeId = firstManagetypeId;
            }
          }
        });

        this.agentSelectedObjTableTotal = response.data.total;
      });
    },
    getAgentManagerId(agentManagerId) {
      this.selectedAgentManagerId = agentManagerId;
    },
    reloadObjList() {
      this.$refs.agentPhysicalObjTable.setCheckObjTable();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/AgentSettings/AgentManager.vue